import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { RefreshCw } from 'lucide-react';
import { apiClient } from '../../utils/apiHelper';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const InterestSetting = () => {
  const [liabilities, setLiabilities] = useState([]);

  useEffect(() => { fetchLiabilities(); }, []);

  const fetchLiabilities = async () => {
    try {
      const response = await apiClient.get('/api/accounts/liabilities'); setLiabilities(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const calculateInterest = (liability) => {
    const startDate = new Date(liability.start_date);
    const currentDate = new Date();
    const monthsElapsed = (currentDate.getFullYear() - startDate.getFullYear()) * 12 + (currentDate.getMonth() - startDate.getMonth());
    const yearsElapsed = monthsElapsed / 12;
    const simpleInterest = (liability.amount * liability.interest_rate * yearsElapsed) / 100;
    const totalAmount = liability.amount + simpleInterest;
    return { simpleInterest, totalAmount, yearsElapsed: yearsElapsed.toFixed(2), monthsElapsed };
  };

  return (
    <div className="p-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>Interest Calculation</CardTitle>
          <Button onClick={fetchLiabilities}>
            <RefreshCw className="w-4 h-4 mr-2" />Refresh
          </Button>
        </CardHeader>
        <CardContent>
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b">
                <th className="text-left p-3">Liability Name</th>
                <th className="text-left p-3">Principal Amount</th>
                <th className="text-left p-3">Interest Rate</th>
                <th className="text-left p-3">Time Period</th>
                <th className="text-left p-3">Simple Interest</th>
                <th className="text-left p-3">Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {liabilities.length === 0 ? (
                <tr><td colSpan="6" className="text-center p-4 text-gray-500">No liabilities found.</td></tr>
              ) : (
                liabilities.map((liability) => {
                  const interest = calculateInterest(liability);
                  return (
                    <tr key={liability.id} className="border-b hover:bg-gray-50">
                      <td className="p-3 font-medium">{liability.liability_name}</td>
                      <td className="p-3">₹{liability.amount.toFixed(2)}</td>
                      <td className="p-3">{liability.interest_rate}%</td>
                      <td className="p-3">{interest.yearsElapsed} years ({interest.monthsElapsed} months)</td>
                      <td className="p-3 text-red-600">₹{interest.simpleInterest.toFixed(2)}</td>
                      <td className="p-3 font-semibold text-orange-600">₹{interest.totalAmount.toFixed(2)}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>

          <div className="mt-6 p-4 bg-blue-50 rounded-lg">
            <h3 className="font-semibold mb-2">Interest Calculation Formula:</h3>
            <p className="text-sm text-gray-600">Simple Interest (SI) = (Principal × Rate × Time) / 100</p>
            <p className="text-sm text-gray-600">Total Amount = Principal + Simple Interest</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default InterestSetting;